import en from './en/en';
import lt from './lt/lt';

export default {
  en,
  lt,
};
